import * as React from 'react';
import * as I18n from 'i18n-js';
import RecentArticles from './recent_articles';
import HomepageCategories from '../homepage_categories';
import HomepageCuratedSetRow from '../homepage_curated_set_row';
import HomepageMosaic from './homepage_mosaic';
import HomepageSell from './homepage_sell';
import HomepageNewsletter from './homepage_newsletter';

import RecentlyViewedListings from '@reverbdotcom/commons/dist/cms/components/recently_viewed_listings';
import CspCollection from '@reverbdotcom/commons/dist/cms/components/csp_collection';
import CmsListingsCollection from '@reverbdotcom/commons/dist/cms/components/cms_listings_collection';
import SearchHeader from '@reverbdotcom/commons/dist/cms/headers/search_header';

import { withUserContext, IUserContext } from '@reverbdotcom/commons/dist/components/user_context_provider';
import { isExperimentEnabled } from '@reverbdotcom/commons/dist/user_context_helpers';
import { reverb_search_CSPSearchRequest_Sort } from '../../../schemas/rql';
import { experiments, US_CON_CODE } from '../../shared/constants';

export class LoggedOutHomepage extends React.Component<IUserContext, {}> {
  renderSearchHeader() {
    if (isExperimentEnabled(this.props.user, 'hide_search_header')) {
      return (
        <div className="pt-half"></div>
      );
    }
    return (
      <SearchHeader
        renderSecondaryImage
        renderSearchSuggestion
      />
    );
  }

  renderMosaic() {
    if (!isExperimentEnabled(this.props.user, experiments.DISCO_MOSAIC)) { return false; }
    if (this.props.user.shippingRegionCode !== US_CON_CODE) { return false; }

    return (
      <div className="homepage-container__component-wrapper">
        <h2 className="homepage__subheading">
          {I18n.t('discovery.homepage.loggedOutNew.trendingNow')}
        </h2>
        <HomepageMosaic />
      </div>
    );
  }

  render() {
    return (
      <div className="homepage bg-white">
        {this.renderSearchHeader()}
        <div className="homepage-container__component-wrapper">
          <RecentlyViewedListings
            title={I18n.t('discovery.recentlyViewed.title')}
            largeTiles
          />
        </div>
        <div className="homepage-container__component-wrapper">
          <h2 className="homepage__subheading">
            {I18n.t('discovery.homepage.loggedOutNew.gearWeLove')}
          </h2>
          <CspCollection
            collectionId="67539"
            ssr={false}
            ctaTargetHref="/collection/reverb-staff-picks"
            sort={reverb_search_CSPSearchRequest_Sort.QUALITY_DESC}
          />
        </div>
        <h2 className="homepage__subheading">
          {I18n.t('discovery.homepage.loggedOutNew.shopByInstrument')}
        </h2>
        <div className="homepage-container__component-wrapper homepage-container__component-wrapper--thin">
          <HomepageCategories noTitle />
        </div>
        {this.renderMosaic()}
        <div className="homepage-container__component-wrapper">
          <h2 className="homepage__subheading">
            {I18n.t('discovery.homepage.loggedOutNew.explore')}
          </h2>
          <RecentArticles title=" " />
        </div>
        {this.props.user.shippingRegionCode === US_CON_CODE &&
          <div className="homepage-container__component-wrapper">
            <h2 className="homepage__subheading">
              {I18n.t('discovery.homepage.loggedOutNew.collections')}
            </h2>
            <HomepageCuratedSetRow noTitle />
          </div>
        }
        <div className="scaling-mb-7 scaling-mt-10">
          <HomepageNewsletter signupReason="loggedouthomepage" />
        </div>
        <div className="homepage-container__component-wrapper">
          <h2 className="homepage__subheading">
            {I18n.t('discovery.homepage.loggedOutNew.latestGear')}
          </h2>
          <CmsListingsCollection
            ctaTargetHref="/marketplace?condition=used"
            conditionSlugs={['used']}
            userShippingRegion={this.props.user.shippingRegionCode}
            componentName="HomepageLatestListings"
            maxCount={12}
            largeTiles
            ssr={false}
          />
        </div>
        <div className="homepage-container__component-wrapper">
          <h2 className="homepage__subheading">
            {I18n.t('discovery.homepage.loggedOutNew.dealsAndSteals')}
          </h2>
          <CmsListingsCollection
            curatedSetId="8"
            componentName="HomepageDealsAndSteals"
            ctaTargetHref="/promo/deals-and-steals"
            maxCount={12}
            largeTiles
            ssr={false}
          />
        </div>
        <div className="scaling-mt-10 pb-5 mobile-pb-0">
          <HomepageSell />
        </div>
      </div>
    );
  }
}

export default withUserContext(LoggedOutHomepage);



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/discovery/homepage/logged_out.tsx